import type { Feature, Polygon, MultiPolygon } from 'geojson';
import { countryCollection } from './world.generated';

const idToName: Record<string, string> = {
  '4': '阿富汗', '8': '阿尔巴尼亚', '12': '阿尔及利亚', '20': '安道尔', '24': '安哥拉',
  '28': '安提瓜和巴布达', '31': '阿塞拜疆', '32': '阿根廷', '36': '澳大利亚', '40': '奥地利',
  '44': '巴哈马', '48': '巴林', '50': '孟加拉国', '51': '亚美尼亚', '52': '巴巴多斯',
  '56': '比利时', '60': '百慕大', '64': '不丹', '68': '玻利维亚', '70': '波黑',
  '72': '博茨瓦纳', '76': '巴西', '84': '伯利兹', '90': '所罗门群岛', '96': '文莱',
  '100': '保加利亚', '104': '缅甸', '108': '布隆迪', '112': '白俄罗斯', '116': '柬埔寨',
  '120': '喀麦隆', '124': '加拿大', '140': '中非', '144': '斯里兰卡', '148': '乍得',
  '152': '智利', '156': '中国', '158': '台湾', '170': '哥伦比亚', '178': '刚果（布）',
  '180': '刚果（金）', '188': '哥斯达黎加', '192': '古巴', '196': '塞浦路斯', '203': '捷克',
  '204': '贝宁', '208': '丹麦', '214': '多米尼加', '218': '厄瓜多尔', '222': '萨尔瓦多',
  '226': '赤道几内亚', '231': '埃塞俄比亚', '232': '厄立特里亚', '233': '爱沙尼亚',
  '242': '斐济', '246': '芬兰', '250': '法国', '260': '法属南方领地', '262': '吉布提',
  '266': '加蓬', '268': '格鲁吉亚', '270': '冈比亚', '275': '巴勒斯坦', '276': '德国',
  '288': '加纳', '300': '希腊', '308': '格林纳达', '320': '危地马拉', '324': '几内亚',
  '328': '圭亚那', '332': '海地', '340': '洪都拉斯', '344': '香港', '348': '匈牙利',
  '352': '冰岛', '356': '印度', '360': '印度尼西亚', '364': '伊朗', '368': '伊拉克',
  '372': '爱尔兰', '376': '以色列', '380': '意大利', '384': '科特迪瓦', '388': '牙买加',
  '392': '日本', '398': '哈萨克斯坦', '400': '约旦', '404': '肯尼亚', '408': '朝鲜',
  '410': '韩国', '414': '科威特', '417': '吉尔吉斯斯坦', '418': '老挝', '422': '黎巴嫩',
  '426': '莱索托', '428': '拉脱维亚', '430': '利比里亚', '434': '利比亚', '438': '列支敦士登',
  '440': '立陶宛', '442': '卢森堡', '446': '澳门', '450': '马达加斯加', '454': '马拉维',
  '458': '马来西亚', '462': '马尔代夫', '466': '马里', '470': '马耳他', '478': '毛里塔尼亚',
  '480': '毛里求斯', '484': '墨西哥', '492': '摩纳哥', '496': '蒙古', '498': '摩尔多瓦',
  '499': '黑山', '504': '摩洛哥', '508': '莫桑比克', '512': '阿曼', '516': '纳米比亚',
  '524': '尼泊尔', '528': '荷兰', '540': '新喀里多尼亚', '548': '瓦努阿图', '554': '新西兰',
  '558': '尼加拉瓜', '562': '尼日尔', '566': '尼日利亚', '578': '挪威', '586': '巴基斯坦',
  '591': '巴拿马', '598': '巴布亚新几内亚', '600': '巴拉圭', '604': '秘鲁', '608': '菲律宾',
  '616': '波兰', '620': '葡萄牙', '624': '几内亚比绍', '626': '东帝汶', '634': '卡塔尔',
  '642': '罗马尼亚', '643': '俄罗斯', '682': '沙特阿拉伯', '686': '塞内加尔', '688': '塞尔维亚',
  '694': '塞拉利昂', '702': '新加坡', '703': '斯洛伐克', '704': '越南', '705': '斯洛文尼亚',
  '706': '索马里', '710': '南非', '716': '津巴布韦', '728': '南苏丹', '729': '苏丹',
  '732': '西撒哈拉', '740': '苏里南', '748': '斯威士兰', '752': '瑞典', '756': '瑞士',
  '760': '叙利亚', '762': '塔吉克斯坦', '764': '泰国', '768': '多哥', '780': '特立尼达和多巴哥',
  '784': '阿联酋', '788': '突尼斯', '792': '土耳其', '795': '土库曼斯坦', '800': '乌干达',
  '804': '乌克兰', '807': '马其顿', '818': '埃及', '826': '英国', '834': '坦桑尼亚',
  '840': '美国', '854': '布基纳法索', '858': '乌拉圭', '860': '乌兹别克斯坦', '862': '委内瑞拉',
  '887': '也门', '894': '赞比亚',
};

export interface CountryFeature {
  id: string | number | undefined;
  name: string;
  feature: Feature<Polygon | MultiPolygon>;
}

export const COUNTRIES: CountryFeature[] = countryCollection.features.map((featureItem) => {
  const id = featureItem.properties?.id;
  const key = id == null ? '' : String(id);
  return {
    id,
    name: idToName[key] ?? featureItem.properties?.name ?? `国家${key}`,
    feature: featureItem as Feature<Polygon | MultiPolygon>,
  };
});